'use es6';

import { List } from 'immutable';
export const FOLD_KEY_FIELD = '__MEASURE__';
export const FOLD_VALUE_FIELD = '__VALUE__';

// https://vega.github.io/vega-lite/docs/fold.html
export const foldTransform = (dataset, {
  fold = [],
  as = ['key', 'value']
}) => {
  fold = List(fold);
  as = List(as);
  if (fold.isEmpty()) {
    return dataset;
  }
  if (as.count() !== 2) {
    throw new Error('Cannot fold to unknown key/value fields');
  }
  const [keyField, valueField] = as;
  return dataset.update('data', data => data.flatMap(row => fold.map(field => row.set(keyField, field).set(valueField, row.get(field)))));
};